module.exports = __webpack_public_path__ + "img/y_p3_y7.b458c483.png";